import { Injectable, inject } from '@angular/core';

import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';
import { LDFeatureFlags, LaunchDarklyTrackingService } from '@frontend/sports/launch-darkly/feature';
import { LiveUrlParam, UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';
import { LaunchDarklyService } from '@frontend/vanilla/features/launch-darkly';
import { Observable } from 'rxjs';

import { FeatureTab } from './event-details-common.models';

export enum LDStreamingTrackingEvents {
    UserAddPickClickRateInEDP = 'UserAddPickClickRateInEDP',
    UserVisitToEDPFromStreaming = 'UserVisitToEDPFromStreaming',
    UserClickOnScoreboardTab = 'UserClickRateOnScoreboardTab',
    UserClickOnStreamingTab = 'UserClickRateOnStreamingTab',
    UserClickOnAnimationTab = 'UserClickRateOnAnimationTab',
    UserClickOnStatisticsTab = 'UserClickRateOnStatisticsTab',
}

@Injectable({
    providedIn: 'root',
})
export class StreamingLaunchDarklyTrackingService {
    private launchDarklyService = inject(LaunchDarklyService);
    private LaunchDarklyTrackingService = inject(LaunchDarklyTrackingService);
    private urlHelper = inject(UrlHelperService);
    private routerEventsService = inject(RouterEventsService);

    private readonly defaultStreamingLD$ = this.launchDarklyService.getFeatureFlagValue$(LDFeatureFlags.DefaultStreamingTab);

    trackAddPickClickInEDPPage(source: SourceOfPick | undefined): void {
        if (source === SourceOfPick.EventDetails && this.hasVisitedFromStreamingPage()) {
            this.LaunchDarklyTrackingService.trackByContext(
                LDFeatureFlags.DefaultStreamingTab,
                LDStreamingTrackingEvents.UserAddPickClickRateInEDP,
                1,
                1,
            );
        }
    }

    trackUserVisitToEDPFromStreamingPage(): void {
        if (this.hasVisitedFromStreamingPage()) {
            this.LaunchDarklyTrackingService.trackByContext(
                LDFeatureFlags.DefaultStreamingTab,
                LDStreamingTrackingEvents.UserVisitToEDPFromStreaming,
                1,
                1,
            );
        }
    }

    trackTabClickInEDP(activeTabId: number): void {
        switch (activeTabId) {
            case FeatureTab.Scoreboard:
                this.LaunchDarklyTrackingService.trackByContext(
                    LDFeatureFlags.DefaultStreamingTab,
                    LDStreamingTrackingEvents.UserClickOnScoreboardTab,
                    1,
                    1,
                );
                return;
            case FeatureTab.Video:
                this.LaunchDarklyTrackingService.trackByContext(
                    LDFeatureFlags.DefaultStreamingTab,
                    LDStreamingTrackingEvents.UserClickOnStreamingTab,
                    1,
                    1,
                );
                return;
            case FeatureTab.Simulation:
                this.LaunchDarklyTrackingService.trackByContext(
                    LDFeatureFlags.DefaultStreamingTab,
                    LDStreamingTrackingEvents.UserClickOnAnimationTab,
                    1,
                    1,
                );
                return;
            case FeatureTab.Statistics:
                this.LaunchDarklyTrackingService.trackByContext(
                    LDFeatureFlags.DefaultStreamingTab,
                    LDStreamingTrackingEvents.UserClickOnStatisticsTab,
                    1,
                    1,
                );
                return;

            default:
                return;
        }
    }

    hasVisitedFromStreamingPage(): boolean {
        const urlHistory = this.routerEventsService.urlHistory;
        if (urlHistory?.length > 1 && decodeURIComponent(urlHistory[urlHistory.length - 2]).includes(this.urlHelper.getLiveUrl(LiveUrlParam.Video))) {
            return true;
        }
        return false;
    }

    get isDefaultStreamingTabEnabled$(): Observable<number> {
        return this.defaultStreamingLD$;
    }
}
